import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  id: `kt_modal_create_user_account`,
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fs-3 el-icon el-dialog__close" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "currentColor",
        d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
      })
    ])
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body scroll-y overflow-auto bg-opacity-50 bg-light" }
const _hoisted_9 = {
  class: "d-flex flex-column scroll-y me-n7 pe-4",
  id: "user__UpdateUserModal_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#user__UpdateUserModal_header",
  "data-kt-scroll-wrappers": "#user__UpdateUserModal_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_12 = { class: "required mb-2" }
const _hoisted_13 = { class: "fv-plugins-message-container text-start" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_16 = { class: "required mb-2" }
const _hoisted_17 = { class: "fv-plugins-message-container text-start" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_21 = { class: "required mb-2" }
const _hoisted_22 = { class: "fv-plugins-message-container text-start" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_25 = { class: "mb-2 required" }
const _hoisted_26 = { class: "position-relative align-items-center" }
const _hoisted_27 = { class: "fv-plugins-message-container text-start" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_31 = { class: "required mb-2" }
const _hoisted_32 = { class: "fv-plugins-message-container text-start" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_35 = { class: "required mb-2" }
const _hoisted_36 = { class: "fv-plugins-message-container text-start" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-3" }
const _hoisted_39 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_40 = { class: "required mb-2" }
const _hoisted_41 = { class: "position-relative align-items-center" }
const _hoisted_42 = { class: "fv-plugins-message-container text-start" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_45 = { class: "mb-2" }
const _hoisted_46 = { class: "position-relative align-items-center" }
const _hoisted_47 = { class: "fv-plugins-message-container text-start" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "row mb-3" }
const _hoisted_50 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_51 = { class: "mb-2" }
const _hoisted_52 = { class: "position-relative align-items-center" }
const _hoisted_53 = { class: "fv-plugins-message-container text-start" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_57 = { class: "fv-row mb-3" }
const _hoisted_58 = { class: "mb-2" }
const _hoisted_59 = { id: "kt_docs_repeater_basic" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = { "data-repeater-item": "" }
const _hoisted_62 = { class: "form-group row" }
const _hoisted_63 = { class: "col-md-12" }
const _hoisted_64 = { class: "input-group d-flex align-items-center mb-1" }
const _hoisted_65 = {
  class: "input-group-text",
  title: "Select as default"
}
const _hoisted_66 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_67 = { class: "input-group-text" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-danger fs-6" }, null, -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-circle text-primary m-1 fs-6" }, null, -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Add another number ")
const _hoisted_76 = [
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = { class: "fv-plugins-message-container" }
const _hoisted_78 = { class: "fv-help-block" }
const _hoisted_79 = { class: "row mb-3" }
const _hoisted_80 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_81 = { class: "card" }
const _hoisted_82 = { class: "card-body p-4" }
const _hoisted_83 = { class: "d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_85 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_86 = { class: "fv-help-block" }
const _hoisted_87 = { class: "table align-middle table-hover table-row-bordered fs-6 gy-3" }
const _hoisted_88 = { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }
const _hoisted_89 = { class: "text-end" }
const _hoisted_90 = { class: "text-truncate fw-bolder badge badge-success" }
const _hoisted_91 = { class: "text-end" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_96 = {
  type: "submit",
  ref: "submitButton",
  id: "vz_update_user_submit",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
}
const _hoisted_97 = { class: "indicator-label" }
const _hoisted_98 = { class: "indicator-progress" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_VZPhone = _resolveComponent("VZPhone")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddSiteModal = _resolveComponent("AddSiteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "form w-100",
        id: "kt_modal_create_user_account__",
        onSubmit: _ctx.cloneUser,
        "validation-schema": _ctx.login,
        ref: "formRef",
        "initial-values": _ctx.initialValues
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("pages.user.addUser")), 1),
              _createElementVNode("div", {
                class: "btn btn-sm btn-icon btn-active-color-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideCreateModal && _ctx.hideCreateModal(...args))),
                type: "reset"
              }, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("common.firstName")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control mb-3 mb-lg-0",
                      type: "text",
                      name: "firstName",
                      autocomplete: "off"
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "firstName" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("common.lastName")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control mb-3 mb-lg-0",
                      type: "text",
                      name: "lastName",
                      autocomplete: "off"
                    }),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_ErrorMessage, { name: "lastName" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("common.email")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control mb-3 mb-lg-0",
                      type: "email",
                      name: "email",
                      placeholder: "Email@example.com",
                      autocomplete: "off"
                    }),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_ErrorMessage, { name: "email" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("pages.user.birthday")), 1),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_Field, {
                        name: "birthday",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Datepicker, _mergeProps({
                            modelValue: _ctx.cloneUserModel.birthday,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cloneUserModel.birthday) = $event))
                          }, field, {
                            enableTimePicker: false,
                            format: _ctx.displayDate,
                            autoApply: true,
                            "model-type": "yyyy-MM-dd",
                            placeholder: _ctx.t('common.dateOfBirth'),
                            teleport: "body",
                            "max-date": _ctx.minDate
                          }), null, 16, ["modelValue", "format", "placeholder", "max-date"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_ErrorMessage, { name: "birthday" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("common.password")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control mb-3 mb-lg-0",
                      type: "password",
                      name: "password",
                      autocomplete: "off"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_el_input, _mergeProps(field, {
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                          "show-password": _ctx.passwordTrue,
                          onFocus: _ctx.clearPassword
                        }), null, 16, ["modelValue", "show-password", "onFocus"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_ErrorMessage, { name: "password" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("pages.user.confirmPassword")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control mb-3 mb-lg-0",
                      type: "password",
                      name: "password_confirmation",
                      autocomplete: "off"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_el_input, _mergeProps(field, {
                          modelValue: _ctx.password_confirmation,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password_confirmation) = $event)),
                          onFocus: _ctx.clearConfirmPassword,
                          "show-password": _ctx.confirmPasswordTrue
                        }), null, 16, ["modelValue", "onFocus", "show-password"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("common.startDate")), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_Field, {
                        name: "startDate",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Datepicker, _mergeProps({
                            modelValue: _ctx.cloneUserModel.startDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cloneUserModel.startDate) = $event))
                          }, field, {
                            enableTimePicker: false,
                            format: _ctx.displayDate,
                            utc: "",
                            autoApply: true,
                            "model-type": "yyyy-MM-dd",
                            placeholder: _ctx.t('common.startDate'),
                            teleport: "body",
                            "min-date": _ctx.minDate
                          }), null, 16, ["modelValue", "format", "placeholder", "min-date"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_ErrorMessage, { name: "startDate" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("common.endDate")), 1),
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_Field, {
                        name: "endDate",
                        autocomplete: "off"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Datepicker, _mergeProps({
                            modelValue: _ctx.cloneUserModel.endDate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cloneUserModel.endDate) = $event))
                          }, field, {
                            enableTimePicker: false,
                            format: _ctx.displayDate,
                            utc: "",
                            autoApply: true,
                            "model-type": "yyyy-MM-dd",
                            placeholder: _ctx.t('common.endDate'),
                            teleport: "body",
                            "min-date": _ctx.minEndDate
                          }), null, 16, ["modelValue", "format", "placeholder", "min-date"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_ErrorMessage, { name: "endDate" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("common.status")), 1),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.cloneUserModel.status,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cloneUserModel.status) = $event)),
                        name: "status"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_el_input, _mergeProps(field, {
                            modelValue: _ctx.cloneUserModel.status,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cloneUserModel.status) = $event)),
                            disabled: ""
                          }), null, 16, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_ErrorMessage, { name: "status" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_FieldArray, {
                      name: "phoneModel",
                      "key-path": "id"
                    }, {
                      default: _withCtx(({ fields, push, remove }) => [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.t("pages.user.phoneNumber")), 1),
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: field.key
                                }, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("div", _hoisted_62, [
                                      _createElementVNode("div", _hoisted_63, [
                                        _createElementVNode("div", _hoisted_64, [
                                          _createElementVNode("span", _hoisted_65, [
                                            _createElementVNode("div", _hoisted_66, [
                                              _createVNode(_component_Field, {
                                                class: "form-check-input",
                                                type: "radio",
                                                id: `defaultPhone_${idx}`,
                                                name: `defaultPhone`,
                                                value: field.key,
                                                modelValue: _ctx.defaultPhoneIndex,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.defaultPhoneIndex) = $event))
                                              }, null, 8, ["id", "value", "modelValue"])
                                            ])
                                          ]),
                                          _createVNode(_component_Field, {
                                            class: "form-control",
                                            name: `phoneModel[${idx}].phoneNumber`,
                                            type: "text",
                                            id: `phoneNumber_${idx}`
                                          }, {
                                            default: _withCtx(({ field }) => [
                                              _createVNode(_component_VZPhone, _mergeProps(field, {
                                                onEmitValidation: 
                                          (value) =>
                                            _ctx.handleValidation(value, idx)
                                        
                                              }), null, 16, ["onEmitValidation"])
                                            ]),
                                            _: 2
                                          }, 1032, ["name", "id"]),
                                          _createElementVNode("span", _hoisted_67, [
                                            _createElementVNode("a", {
                                              href: "javascript:;",
                                              onClick: 
                                          () => {
                                            if (fields.length > 1) {
                                              remove(idx);
                                              const index = fields.findIndex(
                                                (item) =>
                                                  Number(item.key) ==
                                                  Number(item.key) + 1
                                              );
                                              if (index !== -1) {
                                                _ctx.defaultPhoneIndex = Number(
                                                  Number(field.key) + 1
                                                );
                                              } else {
                                                _ctx.defaultPhoneIndex = Number(
                                                  fields[0].key
                                                );
                                              }
                                              _ctx.validationErrors.value.pop();
                                            }
                                          }
                                        
                                            }, _hoisted_70, 8, _hoisted_68)
                                          ])
                                        ])
                                      ]),
                                      (_ctx.validationErrors[idx])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                            _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.t("common.invalidNumber")), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              }), 128)),
                              (!_ctx.validationErrors[fields.length - 1])
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "javascript:;",
                                    onClick: 
                              () => {
                                if (
                                  fields[fields.length - 1].value.phoneNumber !=
                                  ''
                                ) {
                                  push({
                                    id: null,
                                    type: 'CALL',
                                    phoneNumber: '',
                                    defaultPhone: false,
                                  });
                                }
                              }
                            
                                  }, _hoisted_76, 8, _hoisted_73))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode(_component_ErrorMessage, { name: `defaultPhone` })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("h5", null, [
                            _createTextVNode(_toDisplayString(_ctx.t("pages.user.userSite")) + " ", 1),
                            _hoisted_84,
                            (_ctx.siteTableData.length < 1 && _ctx.showErrorSite)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                  _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.t("validation.siteValidation")), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("a", {
                            class: "btn btn-primary btn-sm",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showSiteDialog = true))
                          }, _toDisplayString(_ctx.t("pages.user.assignSite")), 1)
                        ]),
                        _createElementVNode("table", _hoisted_87, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_88, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.t("common.siteName")), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.t("pages.user.role")), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.t("pages.user.status")), 1),
                              _createElementVNode("th", _hoisted_89, _toDisplayString(_ctx.t("pages.user.action")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siteTableData, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(item.siteName), 1),
                                _createElementVNode("td", null, _toDisplayString(item.roleName), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_90, _toDisplayString(item.status), 1)
                                ]),
                                _createElementVNode("td", _hoisted_91, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.removeSite(item, index)),
                                    class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
                                  }, _hoisted_94, 8, _hoisted_92)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("button", {
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.hideCreateModal && _ctx.hideCreateModal(...args))),
                type: "reset"
              }, _toDisplayString(_ctx.t("common.close")), 1),
              _createElementVNode("button", _hoisted_96, [
                _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.t("common.save")), 1),
                _createElementVNode("span", _hoisted_98, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_99
                ])
              ], 512)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ]),
    _createVNode(_component_AddSiteModal, {
      showDialog: _ctx.showSiteDialog,
      siteIdsOptions: _ctx.siteOptions,
      roleOptions: _ctx.roleOptions,
      onCloseAddModal: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showSiteDialog = false)),
      onModalSubmitData: _ctx.submitSiteData
    }, null, 8, ["showDialog", "siteIdsOptions", "roleOptions", "onModalSubmitData"])
  ]))
}